import { render, staticRenderFns } from "./OCRUpload.vue?vue&type=template&id=16fb8577&"
import script from "./OCRUpload.vue?vue&type=script&lang=ts&"
export * from "./OCRUpload.vue?vue&type=script&lang=ts&"
import style0 from "./OCRUpload.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports